import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ControllingPersonRoleDetailCollectionModel } from '../../Models/Models/Customer/ControllingPersonRoleDetailCollectionModel';
import { ControllingPersonRoleDetailModel } from '../../Models/Models/Customer/ControllingPersonRoleDetailModel';

declare var IS_RUNNING_IN_APP_POOL;

export class ControllingPersonDetailsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(customerId: number): Promise<ControllingPersonRoleDetailCollectionModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/ControllingPersonDetails/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId }

    return AjaxWrapper.get<ControllingPersonRoleDetailCollectionModel, any>(url, data);
  }
  public put(detail: ControllingPersonRoleDetailModel): Promise<ControllingPersonRoleDetailModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/ControllingPersonDetails/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { detail: detail }

    return AjaxWrapper.put<ControllingPersonRoleDetailModel, any>(url, data);
  }
}

